module.exports = __webpack_public_path__ + "static/media/shagi_logo_wide_500_centered.7bbdd8b0.png";